import type { RecommendationPageMode } from '../types';

export const FOLIAR_TITLES: Record<RecommendationPageMode, string> = {
	add: 'Nova Recomendação Foliar',
	edit: 'Editar Recomendação Foliar',
	view: 'Informações da Aplicação Foliar',
};

export const FOLIAR_SUBTITLES: Record<RecommendationPageMode, string> = {
	add: 'Cadastre os dados gerais da nova recomendação',
	edit: 'Edite os dados gerais da recomendação',
	view: 'Visualize os dados gerais da recomendação',
};
